import styled from '@emotion/styled'
import { uniq } from 'lodash'

import { Color } from '../../../../constants'
import { Div, Icon, Tooltip } from '../../../../elements'
import { useTranslations } from '../../../../translate'
import { composableZIndex } from '../consts'

const ErrorWrapper = styled(Div)({
  position: 'absolute',
  top: -5,
  right: -5,
  zIndex: composableZIndex.shiftError,
  width: 'fit-content',
})

type ShiftErrorProps = {
  errors: { error: string; isWarning?: boolean }[]
}

export const ShiftError = (props: ShiftErrorProps) => {
  const t = useTranslations()

  if (!props.errors.length) return null

  const isWarning = props.errors.every((e) => e.isWarning)

  return (
    <Tooltip
      text={uniq(props.errors.map((e) => e.error))
        .sort((a, b) => a.localeCompare(b, t.$locale))
        .join(', ')}
      intent="warning"
    >
      <Tooltip.Trigger asChild>
        <ErrorWrapper>
          <Icon
            name="DuotoneExclamationCircle"
            color={isWarning ? Color.YELLOW : Color.RED}
            design="solid"
            size="md-plus"
          />
        </ErrorWrapper>
      </Tooltip.Trigger>
    </Tooltip>
  )
}
